module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  }), _vm._v(" Contents "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/map"
    }
  }, [_vm._v("Map of the Candy Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" Lost Gummy Flavors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" Tropical Treasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" Quicksand Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" Mystery of Gummy Lagoon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" Hagoo’s Surprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" Gum-Gum Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" Special Treats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" Gummy Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 9")])]), _vm._v(" Tropical Burst")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 10")])]), _vm._v(" Sweet Endings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/treasure",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Rock Candy Treasure")]), _vm._v(" Excerpt")])]), _vm._v(" "), _c('p', {
    staticClass: "toce"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/authorbio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Helen Perelman")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb590b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 57
// module chunks = 0